module.exports = __webpack_public_path__ + "static/media/grin-stars.72eb0913.svg";